import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dreamy%20pastel%20illustration%20of%20a%20fluffy%20cloud%20world%20with%20cute%20white%20rabbits%20floating%20among%20pink%20cotton%20candy%20clouds%2C%20soft%20peach%20and%20cream%20gradient%20sky%2C%20tiny%20sparkling%20stars%2C%20whimsical%20fantasy%20atmosphere%2C%20kawaii%20style%2C%20ethereal%20dreamy%20vibe&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
          alt="嫩小兔萌趣世界"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="animate-fadeInUp">
          <p className="text-sm md:text-base font-label text-white/80 tracking-widest mb-3">
            ✦ NEN XIAO TU ✦
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-5 leading-tight">
            萌趣世界
            <span className="block text-2xl md:text-4xl lg:text-5xl mt-2 font-body font-light">
              从这里开始
            </span>
          </h1>
          <p className="text-sm md:text-base text-white/70 max-w-lg mx-auto mb-8 leading-relaxed">
            嫩小兔是深受年轻人喜爱的萌系潮流品牌，汇聚嫩小兔系列周边、玩偶、联名产品与限定礼盒，软萌治愈风格让你爱不释手。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line text-lg"></i>
              探索产品
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/25 font-medium text-sm hover:bg-white/25 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-heart-line text-lg"></i>
              了解品牌
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}